import { render, staticRenderFns } from "./pt-routes-list.vue?vue&type=template&id=0a8b552e&"
import script from "./pt-routes-list.vue?vue&type=script&lang=js&"
export * from "./pt-routes-list.vue?vue&type=script&lang=js&"
import style0 from "./pt-routes-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports